import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock3 } from 'lucide-react';

export default function SettingsHubCard({ item }) {
  const Icon = item.icon;
  const isComingSoon = item.status === 'coming_soon';
  const content = (
    <>
      <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${
        isComingSoon ? 'bg-stone-100 text-stone-400' : 'bg-emerald-50 text-brand-green'
      }`}>
        <Icon className="h-5 w-5" aria-hidden="true" />
      </span>
      <span className="min-w-0 flex-1">
        <span className={`block font-semibold ${isComingSoon ? 'text-stone-600' : 'text-brand-navy'}`}>
          {item.title}
        </span>
        <span className={`mt-1 block text-sm ${isComingSoon ? 'text-stone-400' : 'text-stone-500'}`}>
          {item.description}
        </span>
      </span>
      <span className="flex shrink-0 items-center gap-2">
        <span className={`rounded-full border px-2 py-1 text-[10px] font-bold uppercase tracking-wide ${
          isComingSoon
            ? 'border-stone-200 bg-stone-50 text-stone-400'
            : 'border-emerald-100 bg-emerald-50 text-brand-green'
        }`}>
          {isComingSoon ? (
            <>
              <Clock3 className="mr-1 inline h-3 w-3" aria-hidden="true" />
              Prossimamente
            </>
          ) : 'Disponibile'}
        </span>
        <ArrowRight className={`h-4 w-4 ${isComingSoon ? 'text-stone-300' : 'text-stone-400'}`} aria-hidden="true" />
      </span>
    </>
  );

  if (isComingSoon) {
    return (
      <div
        className="flex min-h-[76px] w-full min-w-0 max-w-full items-center gap-3 rounded-2xl border border-stone-200 bg-white/70 px-4 py-3 opacity-80 sm:px-5"
        aria-disabled="true"
        data-testid={`settings-item-${item.id}`}
      >
        {content}
      </div>
    );
  }

  return (
    <Link
      to={item.route}
      className="group flex min-h-[76px] w-full min-w-0 max-w-full items-center gap-3 rounded-2xl border border-stone-200 bg-white px-4 py-3 shadow-sm transition hover:-translate-y-0.5 hover:border-emerald-200 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 sm:px-5"
      data-testid={`settings-item-${item.id}`}
    >
      {content}
    </Link>
  );
}